import { useMutation, useQueryClient } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

import type { BusinessNote } from '../schemas/note-schema'

interface CreateNoteParams {
  content: string
  referralShareId?: number
  leadInquiryId?: number
}

const createNote = async (
  content: string,
  referralShareId?: number,
  leadInquiryId?: number,
): Promise<BusinessNote | undefined> => {
  return postRequest<BusinessNote>(
    `/business/notes?${
      referralShareId ? 'referral_share_id=' + referralShareId : leadInquiryId ? 'lead_inquiry_id=' + leadInquiryId : ''
    }`,
    {
      content,
    },
  )
}

/**
 * Hook to create a new note
 */
export const useCreateNote = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ content, referralShareId, leadInquiryId }: CreateNoteParams) =>
      createNote(content, referralShareId, leadInquiryId),
    onSuccess: (_, { referralShareId, leadInquiryId }) => {
      // Invalidate the notes list query to trigger a refetch
      if (referralShareId) {
        queryClient.invalidateQueries({
          queryKey: queries.notes.list({ referralShareId }).queryKey,
        })
      }
      if (leadInquiryId) {
        queryClient.invalidateQueries({
          queryKey: queries.notes.list({ leadInquiryId }).queryKey,
        })
      }
    },
  })
}
